import PropTypes from 'prop-types';
import { intlShape } from '@prospectus/common/types/intlShape';

const classicEdxCoursePropTypes = {
  course: PropTypes.shape({
    uuid: PropTypes.string,
    subtitle: PropTypes.string,
    courseCount: PropTypes.number,
    levelType: PropTypes.string,
    cardType: PropTypes.string,
    inProspectus: PropTypes.bool,
    prospectusPath: PropTypes.string,
    owners: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
    })),
    activeCourseRun: PropTypes.shape({
      title: PropTypes.string,
      type: PropTypes.string,
      minEffort: PropTypes.number,
      maxEffort: PropTypes.number,
      weeksToComplete: PropTypes.number,
    }),
  }).isRequired,
  isTestimonialCard: PropTypes.bool,
  columnClass: PropTypes.string,
  intl: intlShape.isRequired,
};

export default classicEdxCoursePropTypes;
